import React from 'react';
import { motion } from 'framer-motion';

const EscalationConsentModal = ({ onShare, onDecline, onClose, loading = false }) => (
  <div
    className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/40"
    role="dialog"
    aria-modal="true"
    aria-labelledby="escalation-consent-title"
  >
    <motion.div
      className="surface-panel max-w-md w-full p-6"
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3, ease: 'easeOut' }}
    >
      <h2 id="escalation-consent-title" className="font-display text-h2 text-ink mb-3">
        Brief your matched CFP?
      </h2>
      <p className="text-body text-ink-muted mb-2">
        Aura will compile a structured packet with your question, Aura&apos;s framing, and
        reconciled advice — so your advisor arrives pre-briefed.
      </p>
      <p className="text-label text-ink-muted mb-6">
        With consent, we include Unified Financial Brain fields (surplus, goals, tax profile).
        Without consent, only a redacted summary is shared. The packet is archived immutably
        for compliance.
      </p>
      <div className="flex flex-col sm:flex-row gap-3">
        <button
          type="button"
          onClick={onShare}
          disabled={loading}
          className="btn-primary flex-1 disabled:opacity-50"
        >
          {loading ? 'Preparing…' : 'Share full context & connect'}
        </button>
        <button
          type="button"
          onClick={onDecline}
          disabled={loading}
          className="btn-secondary flex-1 disabled:opacity-50"
        >
          Connect with redacted summary
        </button>
      </div>
      <button type="button" onClick={onClose} disabled={loading} className="btn-ghost w-full mt-3">
        Cancel
      </button>
    </motion.div>
  </div>
);

export default EscalationConsentModal;
